import { useId } from 'react'
import PropTypes from 'prop-types'
import { Checkbox } from '@theneatcompany/nui'

import useAuth from '@/hooks/useAuth'
import { getMessage } from '@/utils/messages'

export default function RememberMe({ disabled = false }) {
  const id = useId()
  const { rememberMe, handleRememberMeChange } = useAuth()

  return (
    <Checkbox
      id={id}
      label={getMessage('labels.rememberMe')}
      checked={rememberMe}
      disabled={disabled}
      name="rememberMe"
      onChange={() => handleRememberMeChange(!rememberMe)}
    />
  )
}

RememberMe.propTypes = {
  disabled: PropTypes.bool,
}
